import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect } from 'react-router-dom';
import Breadcrumb from '../../components/Breadcrumb';
import Tabs from '../../components/Tabs';
import LocationList from '../LocationList';
import { apiUrl } from '../../config/config';
import './Location.css';
import ScrollToTopOnMount from '../../components/ScrollToTopOnMount';

class Location extends Component {
  constructor() {
    super();
    this.state = {
      locationAreas: [],
    };
  }

  componentDidMount() {
    fetch(`${apiUrl}/locationareas`)
      .then(results => results.json())
      .then((data) => {
        this.setState({ locationAreas: data });
      });
  }

  render() {
    const { match } = this.props;
    const currentArea = typeof match.params.filter === 'undefined' ? null : match.params.filter;
    const tabs = [{ title: '所有據點', link: '/locations', stateIdentifier: null }].concat(this.state.locationAreas.map(elem => ({
      title: elem.title,
      link: `/locations/${elem.name}`,
      stateIdentifier: elem.name,
    })));
    const locationAreaNames = this.state.locationAreas.map(elem => elem.name);
    const shouldRedirect =
      typeof match.params.filter !== 'undefined' &&
      locationAreaNames.length > 0 &&
      locationAreaNames.indexOf(match.params.filter) === -1;

    let locations = this.props.locations;
    if (currentArea) {
      locations = locations.filter(elem => {
        if (elem.locationarea)
        {
          return currentArea === elem.locationarea.name
        }else{
          return false
        }
      });
    }

    return (
      <section className="section">
        <ScrollToTopOnMount />
        <div className="locations container">
          <Breadcrumb {...this.props} />
          <Tabs tabs={tabs} {...this.props} />
          <div className="outter-container">
            <div className="inner-container">
              {locations && <LocationList locations={locations} />}
            </div>
          </div>
          {shouldRedirect && <Redirect to="/locations" />}
        </div>
      </section>
    );
  }
}

Location.propTypes = {
  locations: PropTypes.arrayOf(PropTypes.object).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      filter: PropTypes.string,
    }),
  }),
};

Location.defaultProps = {
  match: {
    params: {
      filter: undefined,
    },
  },
};

const mapStateToProps = state => ({
  locations: state.locations,
});

export default connect(mapStateToProps)(Location);



// WEBPACK FOOTER //
// ./src/containers/page/Location.js